import * as Yup from 'yup';

const UpdateInstallerValidationSchema = (t: any) =>
    Yup.object().shape({
        firstName: Yup.string()
            .min(3, t('firstname_min_length_validation'))
            .max(30, t('firstname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('firstname_required_validation')),
        lastName: Yup.string()
            .min(2, t('lastname_min_length_validation'))
            .max(30, t('lastname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('lastname_required_validation')),
        licenseNo: Yup.string()
            .min(1, t('licence_no_min_length_validation'))
            .max(30, t('licence_no_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('licence_no_required_validation')),
        email: Yup.string()
            .email(t('invalid_email_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('email_required_validation')),
        mobileNo: Yup.string().required(t('mobile_no_required_validation')),
        street: Yup.string()
            .min(3, 'Street should be atleast 3 characters')
            .max(30, 'Street should be a max of 30 characters')
            .trim('Starting spaces are not allowed')
            .required('Street Name required'),
        city: Yup.string()
            .min(3, 'City Name should be atleast 3 characters')
            .max(30, 'City Name should be a max of 30 characters')
            .trim('Starting spaces are not allowed')
            .required('City Name required'),

        zipCode: Yup.string()
            .min(5, 'ZIP code must be at least 5 digits long.')
            .max(10, 'ZIP code cannot exceed 10 digits')
            .matches(/^([1-9]\d{5}|\d{5}(-\d{4})?)$/, 'Please enter a valid zip code')
            .required('Zip Code is required'),
    });

export default UpdateInstallerValidationSchema;
